// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SUBSCRIPTION_TIERS = [
    'PERSONAL',
    'PRO',
    'TEAM',
    'ENTERPRISE'
];
export const SubscriptionNameMap = {
    PERSONAL: 'Personal',
    PRO: 'Business',
    TEAM: 'Team',
    ENTERPRISE: 'Enterprise'
};
export const SubscriptionDescriptionMap = {
    PERSONAL: 'Perfect for side projects and personal experiments',
    TEAM: 'For teams building and shipping together',
    PRO: 'For growing companies with production workloads',
    ENTERPRISE: 'For organizations with advanced security and support needs'
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SUBSCRIPTION_CYCLES = [
    'MONTHLY',
    'YEARLY'
];
export const SubscriptionCycleMap = {
    MONTHLY: 'Monthly',
    YEARLY: 'Annual'
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SUBSCRIPTION_SCHEDULE_REASONS = [
    'MANUAL_DOWNGRADE',
    'PAYMENT_FAILED'
];
export const ScheduleReasonMap = {
    MANUAL_DOWNGRADE: 'Requested manually',
    PAYMENT_FAILED: 'Due to payment failure'
};
